<template>
    <tr>
        <td class="t_center">
            <small class="show" v-if="item.status !== 'scheduled'">{{ item.created_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
            <small class="show" v-else><i class="fa fa-clock-o"></i> {{ item.scheduled_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
        </td>
        <td class="max_w_55 t_center b_r_none">
            <span v-if="typeof item.member !== 'undefined'" class="initial_name" v-pml-tooltip.top-right="item.member.name || $t('consultant')">{{ item.member.name_initials }}</span>
            <span v-else class="initial_name" v-pml-tooltip.top-right="$t('consultant')">-</span>
        </td>
        <td class="max_w_14 p-0 t_center b_r_none">
            <i class="fa" :class="arrowClasses"></i>
        </td>
        <td class="max_w_55 t_center">
            <div  v-if="typeof item.lead !== 'undefined'" v-pml-tooltip.top-right="item.lead.name || $t('lead')">
                <img class="img-circle thumb-sm" :src="item.lead.avatar || `/static/images/avatar.jpg`">
            </div>
            <div  v-else v-pml-tooltip.top-right="$t('lead')">
                <img class="img-circle thumb-sm" src="/static/images/avatar.jpg">
            </div>
        </td>
        <td>
            <p class="m-t-5 m-b-0 t_overflow">{{ item.subject }}</p>
        </td>
        <td class="t_center" v-if="item.status !== 'scheduled'">{{ $t(item.status) }}</td>
        <td class="t_center">
            <a  v-if="item.status !== 'scheduled' && typeof item.lead !== 'undefined'" :href="`mailto:${item.lead.email}?subject=${this.item.subject}&cc=${item.cc}&bcc=${tenant.domain}@pml.email`" class="btn btn-default btn-xs" target="_blank" v-pml-tooltip="$t('reply')"><i class="fa fa-mail-reply"></i></a>
            <router-link :to="{ name: 'deals.show.emails.edit', params: { id: item.deal_id, email: item.id } }" class="btn btn-warning btn-xs" v-pml-tooltip="$t('edit')" v-if="item.status === 'scheduled'">
                <i class="fa-fw fa fa-pencil"></i>
            </router-link>
            <a class="btn btn-primary btn-xs" v-pml-tooltip="$t('show')" @click.prevent="showEmail()"><i class="fa-fw md md-visibility"></i></a>
            <span class="btn btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click.prevent="askToDelete" v-pml-block="isDeleting" v-if="item.status === 'scheduled'"><i class="fa-fw fa fa-times"></i></span>
        </td>
    </tr>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { askToDelete } from 'utils/helpers/sweet-alert'
    import { destroy } from 'services/emails'

    export default {
        name: 'EmailItem',
        data () {
            return {
                isDeleting: false
            }
        },
        props: [ 'item' ],
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            }),
            arrowClasses () {
                return this.item.sender !== 'member' ? 'fa-arrow-left text-primary' : 'fa-arrow-right text_green'
            }
        },
        methods: {
            showEmail () {
                var url = `${process.env.URL_LOCAL}/deals/${this.item.deal_id}/emails/${this.item.id}`
                window.open(url, '', 'height=550,width=850')
            },
            askToDelete () {
                askToDelete()
                    .then((response) => (response.value) ? this.destroy() : null)
            },
            destroy () {
                this.isDeleting = true

                destroy(this.item.deal_id, this.item.id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isDeleting = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/emails/Item.vue